import { useMutation, useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";

type WalletStatementExportPayload = {
  walletId: number | string;
  startDate: string;
  endDate: string;
  format: string;
};

const FETCH_ALL_WALLETS_TRANSACTIONS = async (data) => {
  const response = await api.post(API_ROUTES.GET_ALL_WALLET_TRANSACTIONS, data);
  return response.data;
};

export const getWalletTransactions = (data) => {
  return useQuery({
    queryKey: ["walletTransactions", data],
    queryFn: () => FETCH_ALL_WALLETS_TRANSACTIONS(data),
    enabled: !!data.businessId,
  });
};

const OTHER_CURRENCIES = ["ZAR", "KES", "ZMW", "TZS", "GHS"];

const FETCH_WALLET_CURRENCY_TRANSACTION = async (
  data: any,
  currency: string,
  walletId?: number,
) => {
  const API_MAP: Record<string, string> = {
    NGN: "/wallet/foreign/banktransfer/request/admin/transaction/paginated/filter",
    USD: "/wallet/admin/transaction/paginated/filter",
    OTHER: `/wallet/merchant/bank/transfer/request/${walletId}/mine`,
  };

  const apiUrl = OTHER_CURRENCIES.includes(currency)
    ? API_MAP.OTHER
    : API_MAP[currency] || API_ROUTES.GET_WALLET_CURRENCY_TRANSACTIONS;

  return OTHER_CURRENCIES.includes(currency) && walletId
    ? api.get(apiUrl).then((res) => res.data)
    : api.post(apiUrl, data).then((res) => res.data);
};

export const fetchWalletTransactions = (
  data: any,
  currency: string,
  walletId?: number,
) => {
  return useQuery({
    queryKey: ["walletTransactions", currency, walletId, data],
    queryFn: () => FETCH_WALLET_CURRENCY_TRANSACTION(data, currency, walletId),
    enabled: !!currency,
  });
};

const FETCH_WALLET_DEPOSIT_REQUEST = async (data) => {
  const response = await api.post(API_ROUTES.GET_WALLET_DEPOSIT_REQUESTS, data);
  return response.data;
};

export const getWalletDepositRequest = (data) => {
  return useQuery({
    queryKey: ["walletDepositRequest", data],
    queryFn: () => FETCH_WALLET_DEPOSIT_REQUEST(data),
  });
};

const UPDATE_WALLET_DEPOSIT_REQUEST = async (data) => {
  const response = await api.put(
    `${API_ROUTES.UPDATE_WALLET_DEPOSIT_REQUEST}/${data}`,
  );
  return response.data;
};

export const updateWalletDepositRequest = () => {
  return useMutation(UPDATE_WALLET_DEPOSIT_REQUEST);
};

const EXPORT_WALLET_STATEMENT = async (data: WalletStatementExportPayload) => {
  const response = await api.post(API_ROUTES.EXPORT_WALLET_STATEMENT, data);
  return response.data;
};

export const useWalletStatementExport = () => {
  return useMutation({
    mutationFn: EXPORT_WALLET_STATEMENT,
  });
};
